import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var nearbyItem = /*#__PURE__*/css("display:inline-flex;align-items:baseline;width:296px;", media('>=desktop'), "{margin-right:66px;}");
export var iconContainer = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var iconPlaceholder = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var icon = {
  name: "1ojo403",
  styles: "width:20px;height:20px;vertical-align:-webkit-baseline-middle;"
};
export var details = {
  name: "r42yts",
  styles: "display:inline-block;width:216px;margin-left:10px;margin-bottom:10px;flex-grow:1;"
};
export var name = /*#__PURE__*/css("display:block;", designTokenFonts.bodyBold, " color:", colors.neutral.heavy.default, ";");
export var type = /*#__PURE__*/css("display:block;", designTokenFonts.mini, " color:", colors.neutral.base.default, ";");
export var distance = /*#__PURE__*/css("vertical-align:top;float:right;", designTokenFonts.mini, " color:", colors.neutral.heavy.default, ";");